import audio1 from '../../../../assets/sounds/youth/de/diktat/01.mp3';
import audio2 from '../../../../assets/sounds/youth/de/diktat/02.mp3';

const audioFiles = {
	1: audio1,
	2: audio2,
};
export default audioFiles;
